export type MetaHpfValue = string | number | null;

export type MetaUnileverRow = {
  guid: string;
  distribuidor: string;
  consultor: string;
  coordenador: string;
  executivoBpc: string;
  executivoHf: string;
  regional: string;
  mes: string | number | null;
  ano: string | number | null;
  metaHpf: MetaHpfValue;
};

export type MetaUnileverColumn = {
  key: keyof Omit<MetaUnileverRow, 'guid'>;
  label: string;
  type?: 'text' | 'money' | 'month' | 'year';
  required?: boolean;
};

export type ValidationError = {
  row: number;
  rowIndex?: number;
  field: string;
  value?: string | number | null;
  reason?: string;
  distribuidor?: string;
  regional?: string;
  message: string;
};

export type SkippedRow = {
  row: number;
  distribuidor: string;
  regional: string;
  consultor?: string;
  coordenador?: string;
  executivoBpc?: string;
  executivoHf?: string;
  mes?: string | number | null;
  ano?: string | number | null;
  metaHpf?: MetaHpfValue;
  reasons?: ValidationError[];
};

export type SaveResponse = {
  success: boolean;
  error?: string;
  validationErrors?: ValidationError[];
  data?: {
    columns: MetaUnileverColumn[];
    rows: MetaUnileverRow[];
    updated_at?: string | null;
  };
  changedCount?: number;
  skippedCount?: number;
  skippedRows?: SkippedRow[];
  skippableErrors?: ValidationError[];
  canIgnoreNotFound?: boolean;
  historySaved?: boolean;
};

export type HistoryFieldChange = {
  field: string;
  label: string;
  before: string | number | null;
  after: string | number | null;
};

export type HistoryChange = {
  action: 'insert' | 'update' | 'delete';
  guid: string;
  distribuidor: string;
  fields: HistoryFieldChange[];
};

export type HistoryEntry = {
  id_log: number;
  log_name?: string;
  name: string;
  email: string;
  created_at: string;
  data: {
    action?: string;
    source?: string;
    total_changed?: number;
    total_skipped?: number;
    changes?: HistoryChange[];
    skipped?: SkippedRow[];
  };
};

export const META_UNILEVER_COLUMNS: MetaUnileverColumn[] = [
  { key: 'distribuidor', label: 'Distribuidor', required: true },
  { key: 'consultor', label: 'Consultor' },
  { key: 'coordenador', label: 'Coordenador' },
  { key: 'executivoBpc', label: 'Executivo BPC' },
  { key: 'executivoHf', label: 'Executivo HF' },
  { key: 'regional', label: 'Regional', required: true },
  { key: 'mes', label: 'Mês', type: 'month' },
  { key: 'ano', label: 'Ano', type: 'year' },
  { key: 'metaHpf', label: 'Meta HPF', type: 'money' },
];
